import type { Props as CheckboxProps } from './_Checkbox'
import Checkbox from './_Checkbox'
import CheckboxGroup from './_CheckboxGroup'

type CompoundedComponent = React.ForwardRefExoticComponent<
  CheckboxProps & React.RefAttributes<HTMLInputElement>
> & {
  Group: typeof CheckboxGroup
}

const _Checkbox = Checkbox as CompoundedComponent
_Checkbox.Group = CheckboxGroup

export default _Checkbox
